/*
Generated time: December 23, 2025 12:31
This file was created by the app developer. Feel free to contact the original developer with any questions. It was minified (compressed) by AVADA. AVADA do NOT own this script.
*/
if("function"!=typeof ShippingNotice){class ShippingNotice extends HTMLElement{constructor(){super(),this.init()}init(){var e=Number(this.getAttribute("data-free-shipping")),t=Number(this.getAttribute("data-cart-total-amount")),s=t-Math.round(e*(Shopify.currency.rate?Number(Shopify.currency.rate):1));let i="",n=!1;var a=Math.min(t/e*100,100);s<0?i=window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace("{{ remaining_amount }}",this._formatMoney(Math.abs(s),KROWN.settings.shop_money_format)):(i=window.KROWN.settings.locales.shipping_notice_eligible_for_free,n=!0),this._injectStyles(),this.hasAttribute("data-show-alert")?this.innerHTML=`
          <div class="alert alert--wide alert--${n?"success":"note"}">
            <div class="shipping-notice-content">
              <div class="shipping-message">${i}</div>
              <div class="shipping-progress">
                <div class="progress-bar">
                  <div class="progress-fill ${n?"progress-complete":""}" 
                       style="width: ${a}%"></div>
                </div>
                <div class="progress-info">
                  <span class="current-amount">${this._formatMoney(t,KROWN.settings.shop_money_format)}</span>
                  <span class="target-amount">${this._formatMoney(e,KROWN.settings.shop_money_format)}</span>
                </div>
              </div>
            </div>
          </div>`:this.innerHTML=`
          <div class="shipping-notice-content">
            <div class="shipping-message">${i}</div>
            <div class="shipping-progress">
              <div class="progress-bar">
                <div class="progress-fill ${n?"progress-complete":""}" 
                     style="width: ${a}%"></div>
              </div>
              <div class="progress-info">
                <span class="current-amount">${this._formatMoney(t,KROWN.settings.shop_money_format)}</span>
                <span class="target-amount">${this._formatMoney(e,KROWN.settings.shop_money_format)}</span>
              </div>
            </div>
          </div>`;
          setTimeout(() => {
            const shippingTextEl = document.getElementById("cart_total_shipping");
            if (shippingTextEl) {
              shippingTextEl.textContent = n ? "Kostenlos" : "CHF 7.-";
            }
          }, 50);
        }_injectStyles(){var e;document.querySelector("#shipping-notice-styles")||((e=document.createElement("style")).id="shipping-notice-styles",e.textContent=`
          .shipping-notice-content {
            display: flex;
            flex-direction: column;
            gap: 12px;
          }

          .shipping-progress {
            display: flex;
            flex-direction: column;
            gap: 8px;
          }

          .progress-bar {
            width: 100%;
            height: 8px;
            background-color: #e5e5e5;
            border-radius: 4px;
            overflow: hidden;
            position: relative;
          }

          .progress-fill {
            height: 100%;
            background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
            border-radius: 4px;
            transition: width 0.8s ease-in-out;
            position: relative;
          }

          .progress-complete {
            background: linear-gradient(90deg, #10b981 0%, #059669 100%) !important;
          }

          .progress-fill::after {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
            animation: shimmer 2s infinite;
          }

          @keyframes shimmer {
            0% { left: -100%; }
            100% { left: 100%; }
          }

          .progress-info {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 12px;
            color: #666;
          }

          .current-amount {
            font-weight: bold;
            color: #333;
          }

          .target-amount {
            color: #10b981;
            font-weight: 500;
          }

          @media (max-width: 768px) {
            .shipping-notice-content {
              gap: 10px;
            }
            
            .shipping-progress {
              gap: 6px;
            }
            
            .progress-info {
              font-size: 11px;
            }
          }
        `,document.head.appendChild(e))}_formatMoney(e,t){"string"==typeof e&&(e=e.replace(".",""));let s="";var i=/\{\{\s*(\w+)\s*\}\}/,t=t||moneyFormat;function n(e,t,s,i){return s=s||",",i=i||".",isNaN(e)||null===e?0:(t=(e=(e/100).toFixed(t)).split("."))[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+s)+(t[1]?i+t[1]:"")}switch(t.match(i)[1]){case"amount":s=n(e,2);break;case"amount_no_decimals":s=n(e,0);break;case"amount_with_comma_separator":s=n(e,2,".",",");break;case"amount_no_decimals_with_comma_separator":s=n(e,0,".",",");break;case"amount_no_decimals_with_space_separator":s=n(e,0," ");break;case"amount_with_apostrophe_separator":s=n(e,2,"'")}return t.replace(i,s)}}void 0===customElements.get("shipping-notice")&&customElements.define("shipping-notice",ShippingNotice)}